export default __webpack_public_path__ + "static/media/SePeru-2.4a02c978.jpg";